angular.module("ainapp")
    .controller("stockMovementController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Stock Movement";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Brands = [];
            MainService.BrandsInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Brands = response.data;
                $scope.Brands.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {

                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                };
                                o.data.filter.filters.push(temp);
                            }
                        }

                        MainService.productForMultiSelect(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 50
            };

            $scope.selectProductsOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                filter: "contains",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };

            $scope.selectProductCodeOptions = {
                placeholder: "Select Product Codes...",
                dataTextField: "ProductCode",
                dataValueField: "Id",
                filter: "contains",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.$on('$includeContentLoaded', function (event, templateName) {
                if (templateName === 'templates/common/stockFilterModal.html') {
                    $('#filterModal').modal('show');
                }
            });

            $scope.Init = function () {


                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                    ProductIds: [],
                    WarehouseIds: [],
                    isLoad: false,
                    Keyword: "",
                    BranchId: "",
                }

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {


                        if ($scope.filter.isLoad) {


                            o.data.FromDate = $scope.filter.FromDate;
                            o.data.ToDate = $scope.filter.ToDate;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.WarehouseIds = $scope.filter.WarehouseIds;
                            o.data.Keyword = $scope.filter.Keyword;
                            o.data.BranchId = $scope.filter.BranchId;
                            o.data.ProductGroupId = $scope.filter.ProductGroupId;
                            o.data.ProductParentId = $scope.filter.ProductParentId;

                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);


                            MainService.StockList(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    },

                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            Balance: {
                                type: "number",
                                editable: false,
                            },
                            CalcBalance: {
                                type: "number",
                                editable: false,
                            },
                            AveragePrice: {
                                type: "number",
                                editable: false,
                            },
                            BalanceValue: {
                                type: "number",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },
                            ParentGroupName: {
                                type: "string",
                                editable: false,
                            },
                            Field9: {
                                type: "string",
                                editable: false,
                            },
                            Description: {
                                type: "string",
                                editable: false,
                            },
                            "Brand.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                    field: "Balance",
                    aggregate: "sum"
                }, {
                    field: "CalcBalance",
                    aggregate: "sum"
                }, {
                    field: "BalanceValue",
                    aggregate: "sum"
                },],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "ProductCode",
                        title: "Product Code",
                    },
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                    },
                    {
                        field: "ParentGroupName",
                        title: "Category",
                    },
                    {
                        field: "GroupName",
                        title: "Sub Category",
                    },
                    {
                        field: "CalcBalance",
                        title: "Calc Balance",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcBalance, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    },
                    {
                        field: "Balance",
                        title: "Balance Quantity",
                        template: "<div style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    },
                    {
                        field: "AveragePrice",
                        title: "Avg Price",
                        template: "<div style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                    },
                    {
                        field: "BalanceValue",
                        title: "Total Value",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceValue, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    }, {
                        field: "Brand.Name",
                        title: "Brand",
                    },
                    {
                        field: "Description",
                        title: "Description",
                    },
                    {
                        field: "Field9",
                        title: "Manufacturer ",
                    }

                ],
            };

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.filterData = function () {
                $scope.filter.isLoad = true;
                $('#filterModal').modal('hide');
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $('#filterModal').modal('show');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


        }])
